import { List } from 'immutable'
import { LIVE_ACCESS_SUBSCRIPTION_CODE } from 'services/live-access-events/constants'

const PREMIUM_SUBSCRIPTION = 802

export function isLiveAccessFeature (feature, contentPolicyPolicyId = null) {
  const subscriptions = feature.getIn(['offerings', 'subscriptions'], List())
  return contentPolicyPolicyId === PREMIUM_SUBSCRIPTION
    || subscriptions.first() === LIVE_ACCESS_SUBSCRIPTION_CODE
}

export default isLiveAccessFeature
